export default {"src":"/_next/static/media/check.80fcf72a.svg","height":18,"width":25};